import { paginatedTransform } from 'src/services/skuit/utils'
import { PaginatedResponse, UnitLoc } from '../../api/models'

import { API, CustomAxiosConfig } from './types'

export class Units {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<UnitLoc>> => {
    const response = await this.api.get('/logistics/units', config)
    return paginatedTransform(UnitLoc)(response.data)
  }
}
